export const BUS_IFRAME_ELM_ID = 'busIframeElm';
